export interface LoginPayload {
  email: string;
  password: string;
}

export interface ChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
}

export enum Roles {
  SUPER_ADMIN = 'SUPER_ADMIN',
  CLIENT = 'CLIENT',
  DEVICE_USER = 'DEVICE_USER',
  DOMAIN_USER = 'DOMAIN_USER',
}

export interface User {
  email: string;
  password: string;
  _id: string;
  token: string;
  role: Roles;
  name: string;
  isPasswordChanged: boolean;
  twoFA_enabled: boolean;
}

export interface Update2FAPayload {
  twoFA: boolean;
}

export interface ConfirmAuthenticatorPayload {
  otp: string;
  pendingSecret: string;
  name: string;
}

export interface Authenticator {
  name: string;
  qrCode?: string;
  secretKey?: string;
  pendingSecret?: string;
}
